<div class="avatar-container flex flex-col shrink-0 justify-center items-center relative" [ngClass]="classes">
    <div *ngIf="imageUrl" class="img-wrapper">
        <img [src]="imageUrl" class="avatar-img" [ngClass]="[size]" />
    </div>

    <ng-container *ngIf="!imageUrl && userName">
        <p class="avatar-name text-right">{{ userName }}</p>
    </ng-container>

    <ng-container *ngIf="!imageUrl && !userName">
        <mat-icon svgIcon="user"></mat-icon>
    </ng-container>

    <ng-container *ngIf="status">
        <div class="avatar-status absolute w-3 h-3 -right-1 -bottom-1"></div>
    </ng-container>
</div>